// extracted by css-extract-rspack-plugin
export default {"section":"yBgXyYq2fob7C89m"};